__turbopack_context__.v({
  "Arrow": "index-module__Gr5vIa__Arrow",
  "ArrowFill": "index-module__Gr5vIa__ArrowFill",
  "ArrowInnerStroke": "index-module__Gr5vIa__ArrowInnerStroke",
  "ArrowOuterStroke": "index-module__Gr5vIa__ArrowOuterStroke",
  "Item": "index-module__Gr5vIa__Item",
  "ItemIndicator": "index-module__Gr5vIa__ItemIndicator",
  "ItemText": "index-module__Gr5vIa__ItemText",
  "List": "index-module__Gr5vIa__List",
  "Popup": "index-module__Gr5vIa__Popup",
  "Positioner": "index-module__Gr5vIa__Positioner",
  "ScrollArrow": "index-module__Gr5vIa__ScrollArrow",
  "Select": "index-module__Gr5vIa__Select",
  "Value": "index-module__Gr5vIa__Value",
});
